import { Flex } from 'antd';
import CardDetailButton from '../cardDetailButton/cardDetailButton';
import InteractiveCard from '../common/interactiveCard';
import CardData from '../dashboard/cardData';
import { Divider } from '../Ant';
import { useTranslation } from 'react-i18next';
import { Calendar, Clipboard, ShieldTick, UserOctagon } from '../icons';
import { IConflictCheck } from '../../interface/conflictCheck';
import dayjs from 'dayjs';
import { ROUTES } from '../../constants/constants';
import { useNavigationStack } from '../../context/NavigationStackContext';
import {
  conflictCheckCardBorderColorMapping,
  conflictCheckTagColorMapping,
} from '../../constants/conflictSearch';

const ConflictCheckCard = ({ conflictCheck }: { conflictCheck: IConflictCheck }) => {
  const { t } = useTranslation();
  const { push } = useNavigationStack();
  const handleNavigateToDetail = () => {
    push(`${ROUTES.CONFLICT_CHECKS}/${conflictCheck.id}`);
  };
  return (
    <InteractiveCard
      data-testid="conflict-check-card"
      className={`pointer w-full conflict-card ${conflictCheckCardBorderColorMapping[conflictCheck?.statusCode]}`}
      onActivate={handleNavigateToDetail}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex
          justify="center"
          align="center"
          className={`status-chip ${conflictCheckTagColorMapping[conflictCheck?.statusCode]}`}
        >
          {t(`conflict:status.${conflictCheck.statusCode}`)}
        </Flex>
        <Flex gap={10} align="center">
          <CardDetailButton
            onOpen={handleNavigateToDetail}
            testId="conflict-check-card-go-detail"
          />
        </Flex>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="matter"
          icon={<Clipboard />}
          title={t('common:subject')}
          content={conflictCheck?.subject ?? '-'}
          contentclass="lineclamp-1"
        />
        <CardData
          icon={<ShieldTick />}
          type="transaction"
          title={t('conflict:responsiblePerson')}
          content={conflictCheck?.responsibleUser?.fullName ?? '-'}
        />
        <Divider />
        <Flex justify="space-between">
          <CardData
            icon={<UserOctagon />}
            type="transaction"
            title={t('conflict:processedBy')}
            content={conflictCheck?.checkedByUser?.fullName ?? '-'}
          />
          <CardData
            icon={<Calendar />}
            type="transaction"
            title={t('conflict:createdOn')}
            content={dayjs(conflictCheck?.createdOn).format('MMM DD, YYYY')}
          />
        </Flex>
      </Flex>
    </InteractiveCard>
  );
};

export default ConflictCheckCard;
